package org.multipaz.wallet.shared

class WalletBackendEncryptionKeyMismatchException(message: String? = null): WalletBackendException(message)